import type { SVGProps } from 'react';
import * as React from 'react';

const SvgArrow16 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.334 8H2.667m0 0 4 4m-4-4 4-4"
    />
  </svg>
);
export default SvgArrow16;
